<template>
  <div>
    <q-card
      ref="card"
      flat
      square
      class="cursor-pointer showing"
      :class="{
        published: showing && showing.published,
        'not-relevant': dim
      }"
      :style="colorStyle + '; left: ' + left + 'px; top: ' + top + 'px; width: ' + width + 'px;'"
      @dblclick="$emit('select-showing-detail', showing)"
      @contextmenu.stop.prevent="$emit('select-showing-detail', showing)"
      @click="$emit('select-showing', showing)"
    >
      <q-card-section
        horizontal
        class="overflow-hidden"
        style="height: 53px;"
      >
        <img
          v-if="showPosters && width > 150"
          class="poster-img"
          :class="showing && showing.published ? 'poster-img-small' : ''"
          :src="showing.movie && showing.movie.posterImageSmallUrl"
        >
        <q-card-section
          v-if="width >= 100"
          class="q-pa-xs overflow-hidden"
        >
          <q-card-section class="q-px-xs q-py-none ellipsis text-bold text-left">
            {{ showing.movie && showing.movie.name }}
          </q-card-section>
          <q-card-section
            class="q-pl-none q-pr-xs q-py-none ellipsis text-left"
          >
            <q-chip
              v-if="showRelativeTimeChips && showRelativeStartTime"
              class="text-no-wrap ellipsis"
              size="sm"
              dense
              square
              color="green"
              text-color="white"
            >
              {{ relativeStartTime }}
            </q-chip>
            <q-chip
              v-else-if="showRelativeTimeChips && showRelativeEndTime"
              class="text-no-wrap ellipsis"
              size="sm"
              dense
              square
              color="red"
              text-color="white"
            >
              {{ relativeEndTime }}
            </q-chip>
            <q-chip
              v-if="showTimeChips"
              class="text-no-wrap ellipsis"
              size="sm"
              dense
              square
              color="white"
              text-color="dark"
            >
              {{ startTime }} - {{ endTime }}
            </q-chip>
            <rated
              v-if="showRating && showing.movie.rating"
              class="text-no-wrap ellipsis"
              :rated="showing.movie.rating"
              :rating-reason="showing.movie.ratingReason"
              :outline="false"
              :color="'secondary'"
              :border-radius="1"
              :size="'sm'"
              dense
            />
            <q-chip
              v-if="showPriceCard"
              size="sm"
              dense
              color="primary"
              text-color="white"
            >
              {{ showing.priceCard && showing.priceCard.name }}
            </q-chip>
            <q-chip
              v-if="showSeatChart && showing.overrideSeatChart && showing.customSeatChart"
              size="xs"
              square
            >
              <q-avatar
                icon="event_seat"
                color="red"
                text-color="white"
              />
              {{ showing.customSeatChart.name }}
            </q-chip>
            <showing-badge
              v-for="showingBadge in (showShowingBadges ? showing.showingBadges.data : [])"
              :key="showingBadge.id"
              :showing-badge="showingBadge"
              size="xs"
              outline
            />
            <q-space />
          </q-card-section>
        </q-card-section>
        <q-space />
        <div
          v-if="width < 100"
          class="full-width"
        >
          <div
            class="text-bold overflow-hidden text-no-wrap q-ma-none q-py-none q-px-xs full-width"
            style="line-height: 25px"
          >
            {{ showing.movie.name }}
          </div>
          <div
            class="text-h6 overflow-hidden text-no-wrap q-ma-none q-py-none q-px-xs text-center full-width"
            style="line-height: 25px"
          >
            {{ showing.ticketsSold }}
          </div>
        </div>
        <div
          v-else
          class="text-center q-px-xs"
          style="padding-top: 3px;"
        >
          <div
            class="text-h6 text-center"
            style="height: 20px;"
          >
            {{ showing.ticketsSold }}
          </div>
          <div
            class="text-subtitle2 text-center q-pt-xs"
            style="white-space: nowrap; font-size: 12px;"
          >
            / {{ showing.screen.seatCount }}&nbsp;
          </div>
        </div>
        <q-icon
          v-if="showing && showing.private"
          name="visibility_off"
          color="negative"
          style="position: absolute; top: 22px; right: 3px;"
        >
          <q-tooltip>
            This showing is private and will not show up on the website
          </q-tooltip>
        </q-icon>
      </q-card-section>

      <template v-if="showTimes">
        <q-chip
          v-if="showRelativeTimes && showRelativeStartTime && relativeStartTime"
          class="text-no-wrap ellipsis"
          size="sm"
          dense
          color="green"
          text-color="white"
          style="position: absolute; bottom: -23px; left: -8px; border-radius: 0px 0px 5px 5px"
        >
          {{ relativeStartTime }}
        </q-chip>
        <q-chip
          v-else
          size="sm"
          dense
          :outline="!highlightStarting"
          color="green"
          text-color="white"
          class="text-no-wrap ellipsis time-chip"
          :class="highlightStarting ? '' : 'outline-time-chip'"
          style="position: absolute; bottom: -23px; left: -8px; border-radius: 0px 0px 5px 5px"
        >
          {{ startTime }}
        </q-chip>

        <template v-if="width >= 100">
          <q-chip
            v-if="showRelativeTimes && showRelativeEndTime && relativeEndTime"
            class="text-no-wrap ellipsis"
            size="sm"
            dense
            color="red"
            text-color="white"
            style="position: absolute; bottom: -23px; right: -8px; border-radius: 0px 0px 5px 5px"
          >
            {{ relativeEndTime }}
          </q-chip>
          <q-chip
            v-else
            size="sm"
            dense
            :outline="!highlightEnding"
            color="red"
            text-color="white"
            class="text-no-wrap ellipsis time-chip"
            :class="highlightEnding ? '' : 'outline-time-chip'"
            style="position: absolute; bottom: -23px; right: -8px; border-radius: 0px 0px 5px 5px"
          >
            {{ endTime }}
          </q-chip>
        </template>
      </template>
      <showing-progress-bar
        v-if="showProgressBar && width >= 100"
        style="position: relative; top: -4px;"
        :showing="showing"
        width
      />
    </q-card>
  </div>
</template>

<script>

import { date } from 'quasar'
import { timeToMinutes } from 'src/models/schedule/TimeSlot'
import Showing from 'src/models/showing/Showing'
import ShowingProgressBar from 'src/modules/admin/report/ShowingProgressBar'
import ShowingBadge from 'src/modules/admin/showing-badge/components/ShowingBadge'
import Rated from 'src/modules/consumer/components/Rated'

const yMargin = 5

export default {
  name: 'ShowingSlot',
  components: {
    ShowingBadge,
    ShowingProgressBar,
    Rated
  },
  props: {
    showing: {
      type: Showing,
      required: true
    },
    viewOptions: {
      type: Object,
      required: true
    },
    isToday: {
      type: Boolean,
      required: false,
      default: false
    },
    currentMinutes: {
      type: Number,
      required: false,
      default: 0
    },
    pixelsPerMinute: {
      type: Number,
      required: false,
      default: 0
    },
    isNowNearShowtimes: {
      type: Boolean,
      required: false,
      default: false
    },
    startingY: {
      type: Number,
      required: false,
      default: 0
    },
    totalItemHeight: {
      type: Number,
      required: false,
      default: 70
    },
    screens: {
      type: Array,
      required: false,
      default: null
    }
  },
  configuration: ['currentSite'],
  emits: ['select-showing-detail', 'select-showing', 'showing-slot-created', 'showing-slot-destroyed'],
  computed: {
    top () {
      const screenIndex = this.screenIndex(this.showing.screen.id)

      return this.startingY +
        screenIndex * this.totalItemHeight +
        yMargin
    },
    left () {
      return this.startTimeMinutes * this.pixelsPerMinute
    },
    width () {
      return (this.showing.totalDurationMinutes) * this.pixelsPerMinute
    },
    right () {
      return this.left + this.width
    },
    startTime () {
      return date.formatDate(this.showing.siteTime, 'h:mmA').slice(0, -1)
    },
    startTimeMinutes () {
      return timeToMinutes(this.showing.siteTime)
    },
    endTime () {
      const time = date.addToDate(this.showing.siteTime, { minutes: this.showing.totalDurationMinutes })
      return date.formatDate(time, 'h:mmA').slice(0, -1)
    },
    endTimeMinutes () {
      const time = date.addToDate(this.showing.siteTime, { minutes: this.showing.totalDurationMinutes })
      return timeToMinutes(time)
    },
    color () {
      return this.showing.movie?.color || '#444'
    },
    colorStyle () {
      return this.colorStyleHelper(this.color)
    },
    showTimeHeader () {
      return this.viewOptions.showTimeHeader
    },
    showTimeSlotHeader () {
      return this.viewOptions.showTimeSlotHeader
    },
    showTimes () {
      return this.viewOptions.showTimes
    },
    showTimeChips () {
      return this.viewOptions.showTimeChips
    },
    showRating () {
      return this.viewOptions.showRating
    },
    showSeatChart () {
      return this.viewOptions.showSeatChart
    },
    showPriceCard () {
      return this.viewOptions.showPriceCard
    },
    showShowingBadges () {
      return this.viewOptions.showShowingBadges
    },
    showPosters () {
      return this.viewOptions.showPosters
    },
    showProgressBar () {
      return this.viewOptions.showProgressBar
    },
    showRelativeTimeChips () {
      return this.viewOptions.showRelativeTimeChips
    },
    showRelativeTimes () {
      return this.viewOptions.showRelativeTimes
    },
    highlightStarting () {
      return (
        this.viewOptions.highlightStartingShowings &&
        Math.abs(this.currentMinutes - timeToMinutes(this.showing.siteTime)) < 60
      ) || (
        !this.viewOptions.highlightStartingShowings &&
        this.highlightCurrent
      )
    },
    highlightEnding () {
      return (
        this.viewOptions.highlightEndingShowings &&
        Math.abs(this.currentMinutes - timeToMinutes(this.showing.siteEndTime)) < 60
      ) || (
        !this.viewOptions.highlightEndingShowings &&
        this.highlightCurrent
      )
    },
    highlightCurrent () {
      return this.viewOptions.highlightCurrentShowings &&
        this.currentMinutes > timeToMinutes(this.showing.siteTime) &&
        this.currentMinutes < timeToMinutes(this.showing.siteEndTime)
    },
    dim () {
      return this.isToday &&
      this.isNowNearShowtimes &&
      (
        this.viewOptions.highlightStartingShowings ||
        this.viewOptions.highlightEndingShowings ||
        this.viewOptions.highlightCurrentShowings
      ) &&
      !(
        this.highlightStarting ||
        this.highlightEnding ||
        this.highlightCurrent
      )
    },
    isHighlighted () {
      return !this.dim && (
        this.highlightStarting ||
        this.highlightEnding ||
        this.highlightCurrent
      )
    },
    colorByOccupancy () {
      return this.viewOptions.colorByOccupancy
    },
    showRelativeStartTime () {
      if (!this.isToday) return false

      // if (this.isHighlighted) return true

      const isCurrent = this.showing.siteTime < date.addToDate(this.currentSite.siteTimeWithSeconds, { minutes: 60 }) &&
        this.showing.siteTime > date.addToDate(this.currentSite.siteTimeWithSeconds, { minutes: -60 })

      return isCurrent
    },
    showRelativeEndTime () {
      if (!this.isToday) return false

      // if (this.isHighlighted) return true

      const isCurrent = this.showing.siteEndTime < date.addToDate(this.currentSite.siteTimeWithSeconds, { minutes: 60 }) &&
        this.showing.siteEndTime > date.addToDate(this.currentSite.siteTimeWithSeconds, { minutes: -60 })

      return isCurrent
    },
    relativeStartTime () {
      const time = this.showing.siteTime.relativeTime({ compact: true, relativeTo: this.currentSite.siteTimeWithSeconds })

      return time ? `Start${_.endsWith(time, 'ago') ? 'ed' : 's in'} ${time}` : false
    },
    relativeEndTime () {
      const time = this.showing.siteEndTime.relativeTime({ compact: true, relativeTo: this.currentSite.siteTimeWithSeconds })

      return time ? `End${_.endsWith(time, 'ago') ? 'ed' : 's in'} ${time}` : false
    }
  },
  created () {
    this.$emit('showing-slot-created', this)
  },
  unmounted () {
    this.$emit('showing-slot-destroyed', this)
  },
  methods: {
    screenIndex (screenId) {
      return this.screens ? _.indexOf(_.map(this.screens, 'id'), +screenId) : 0
    },
    colorStyleHelper (color) {
      // Color by movie
      if (!this.colorByOccupancy) {
        return 'color: ' + color + '; border-color: ' + color + '; background-color: ' + color + '33;'
      }

      const occupancyFactor = this.showing.ticketsSold / (this.showing.screen.seatCount - this.showing.heldSeatCount)

      // Color by occupancy (Grey for less than 1/4 occupied)
      const greyscaleForLowOccupancy = 0.8
      const greyscale = occupancyFactor < 0.25 ? greyscaleForLowOccupancy : 0

      // Spectrum of Green to Red (Red is 0, Green is 120)
      const maxHueValue = 120 // Green
      const hueSensitivity = 1.1 // Make slightly more senstive, e.g. 50% occupancy is more than 50% of the way to Red
      const hueForOccupancy = maxHueValue - Math.min(occupancyFactor * maxHueValue * hueSensitivity, maxHueValue)
      color = `hsl(${hueForOccupancy}, 100%, ${hueForOccupancy < 50 ? 40 : 30}%)`
      const bgColor = `hsl(${hueForOccupancy}, 80%, 90%)`

      const opacitySensivity = 2
      const opacity = Math.max(occupancyFactor * opacitySensivity, 0.30)

      return `
        color: ${color};
        border-color: ${color};
        background-color: ${bgColor};
        opacity: ${opacity};
        filter: grayscale(${greyscale})
      `
    }
  }
}

</script>

<style lang="scss" scoped>
  .poster-img {
    width: 40px;
    height: 56px;
  }

  .poster-img-small {
    width: 36px;
    height: 52px;
  }

  .showing {
    border: solid 2px;
    position: absolute;
    height: 60px;
    background: white;
    z-index: 4;
  }

  .published {
    border-width: 4px;
  }

  .poster-wrapper {
    width: 40px;
    height: 60px;
    overflow: hidden;
  }

  .not-relevant {
    opacity: 0.3;
  }

  .time-chip {
    font-weight: 500;
  }

  .outline-time-chip {
    border-top: none;
    border-left: 1px solid;
    border-right: 1px solid;
    background-color: #FFFB !important;
  }

</style>
